import React, { useEffect, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

/* ─── Clés réelles en base — même ordre que le tableau ─── */
const MONTH_KEYS = ['M','M+1','M+2','M+3','M+4','M+5','M+6','M+7','M+8','M+9','M+10','M+11'];

const Graph7 = ({ onBarClick, activeKey }) => {
  const [donnees, setDonnees] = useState([]);
  const chartRef = useRef(null);

  useEffect(() => {
    fetch(`${API}/stock_projete`)
      .then((res) => {
        if (!res.ok) throw new Error('Erreur API');
        return res.json();
      })
      .then((data) => {
        console.log('Données reçues :', data);
        setDonnees(data);
      })
      .catch((err) =>
        console.error('Erreur chargement stock_projete depuis API :', err)
      );
  }, []);

  const labels = donnees.map((ligne) => {
    const date = new Date(ligne.Mois);
    const mois = String(date.getMonth() + 1).padStart(2, '0');
    const annee = String(date.getFullYear()).slice(-2);
    return `${mois}/${annee}`;
  });

  const valeurs = donnees.map((ligne) => ligne.Montant || 0);

  // Barre active en surbrillance, les autres légèrement atténuées
  const backgroundColors = valeurs.map((_, i) => {
    const ratio = i / valeurs.length;
    const r = 54 + Math.round(200 * ratio);
    const g = 162;
    const b = 235 - Math.round(100 * ratio);
    const isActive = activeKey === MONTH_KEYS[i];
    const opacity = activeKey && !isActive ? 0.3 : 0.7;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  });

  const borderColors = valeurs.map((_, i) => {
    const ratio = i / valeurs.length;
    const r = 54 + Math.round(200 * ratio);
    const g = 162;
    const b = 235 - Math.round(100 * ratio);
    const isActive = activeKey === MONTH_KEYS[i];
    return isActive
      ? `rgba(${r}, ${g}, ${b}, 1)`
      : `rgba(${r}, ${g}, ${b}, 0.8)`;
  });

  const borderWidth = valeurs.map((_, i) =>
    activeKey === MONTH_KEYS[i] ? 3 : 1
  );

  const data = {
    labels,
    datasets: [
      {
        label: 'Stock projeté',
        data: valeurs,
        backgroundColor: backgroundColors,
        borderColor: borderColors,
        borderWidth,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => {
            const val = context.parsed.y ?? context.parsed;
            return typeof val === 'number'
              ? val.toLocaleString('fr-FR')
              : val;
          },
          // Indique que la barre est cliquable
          title: (items) => {
            const idx = items[0]?.dataIndex;
            const key = MONTH_KEYS[idx];
            return `${items[0]?.label}${key ? ' — cliquer pour filtrer' : ''}`;
          },
        },
      },
      datalabels: { display: false },
    },
    scales: {
      y: { beginAtZero: true },
      x: { title: { display: true, text: 'Mois' } },
    },
    // Curseur pointer sur les barres
    onHover: (event, elements) => {
      event.native.target.style.cursor = elements.length ? 'pointer' : 'default';
    },
    onClick: (event, elements) => {
      if (!elements.length || !onBarClick) return;
      const idx = elements[0].index;
      const key = MONTH_KEYS[idx];
      if (key) onBarClick(key);
    },
  };

  return (
    <div>
      <Bar ref={chartRef} data={data} options={options} height={500} width={600} />
      {activeKey && (
        <div style={{
          textAlign: 'center',
          fontSize: '12px',
          color: '#185FA5',
          marginTop: '6px',
          fontStyle: 'italic',
        }}>
          Filtre actif : {activeKey} — cliquez à nouveau pour désactiver
        </div>
      )}
    </div>
  );
};

export default Graph7;